import * as React from 'react'
import { ChevronRight, Home } from 'lucide-react'
import { cn } from '../../lib/utils'

export interface BreadcrumbItem {
  label: string
  href?: string
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[]
  onNavigate?: (href: string) => void
  className?: string
}

export function Breadcrumbs({ items, onNavigate, className }: BreadcrumbsProps) {
  if (items.length === 0) return null

  return (
    <nav aria-label="Breadcrumb" className={cn('flex items-center', className)}>
      <ol className="flex items-center gap-1">
        {items.map((item, index) => {
          const isFirst = index === 0
          const isLast = index === items.length - 1
          const isClickable = !isLast && !!item.href

          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/50 flex-shrink-0" />
              )}
              {isClickable ? (
                <button
                  onClick={() => onNavigate?.(item.href!)}
                  className="flex items-center gap-1.5 text-[13px] text-muted-foreground hover:text-foreground transition-colors rounded-md px-1.5 py-0.5 hover:bg-muted/60"
                >
                  {isFirst && <Home className="h-3.5 w-3.5" />}
                  <span>{item.label}</span>
                </button>
              ) : (
                <span
                  className={cn(
                    'flex items-center gap-1.5 text-[13px] px-1.5 py-0.5 rounded-md',
                    isLast
                      ? 'text-foreground font-medium bg-muted/40'
                      : 'text-muted-foreground'
                  )}
                >
                  {isFirst && <Home className="h-3.5 w-3.5" />}
                  <span>{item.label}</span>
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
